import { Component } from '@angular/core';
import { Information, InformationActionType } from 'src/smoothr-web-app-core/models/Information';

@Component({
	selector: 'app-single-card-in-slide',
	templateUrl: './single-card-in-slide.component.html',
	styleUrl: './single-card-in-slide.component.scss',
})
export class SingleCardInSlideComponent {
	information: Information = {
		_id: '1',
		from: new Date(),
		to: new Date(),
		title: {
			en: 'Hot Dog Chili Pepper',
			de: '',
		},
		description: {
			en: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem',
			de: '',
		},
		image: {
			original: '',
			large: '../assets/eintracht/image_247.svg',
			thumb: '',
			medium: '',
		},
		url: '',
		actions: [
			{
				type: InformationActionType.PRIMARY,
				name: {
					en: '',
					de: '',
				},
			},
		],
	};

	constructor() {}
}
